import React, { Component } from 'react';
import { MsalContext } from '@azure/msal-react';

import Menu from '../../../components/maz-tu-info-bees/maz-tu-info-bees-admin/Menu';
import MazTuInfoBeesLoader from '../../../components/maz-tu-info-bees/maz-tu-info-bees-loader/MazTuInfoBeesLoader';
import MazTuInfoBeesToast from '../../../components/maz-tu-info-bees/maz-tu-info-bees-toast/MazTuInfoBeesToast';

import styles from './styles.module.scss';
import { defaultProps, propTypes } from './types';
import { MenuItems } from './MenuItems';

import { callMsGraph } from '../../../graph';
import { loginRequest } from '../../../authConfig';
import fetchAPI from '../../../utils/fetchAPI';
import { setCookie } from '../../../utils/cookiesUtils';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

/*
 * It renders a menu on the left and a component on the right.
 * The component on the right is determined by the active menu item
 */
class AdminMain extends Component {
  static contextType = MsalContext;

  constructor(props) {
    super(props);
    this.state = {
      menuItems: MenuItems,
      toastOpen: false,
      snackbar: {
        open: false,
        title: '',
        message: '',
        severity: 'info', // error | success | info | warning
      },
      loaderOpen: false,
    };
  }

  componentDidMount() {
    // this.setActiveByIndex(1);
    this.setActiveBySubmenuTitle(MenuItems[0], 'franja');
    this.requestProfileData();
  }

  getToken = () => {
    const account = this.context.accounts[0];
    if (!account) {
      console.log('NO HAY CUENTA AUTENTICADA');
      return Promise.reject('No authenticated account');
    }

    return this.context.instance.acquireTokenSilent({
      ...loginRequest,
      account: account,
      forceRefresh: false,
    }).catch((e) => {
      console.error(e);
      if (e instanceof InteractionRequiredAuthError) {
        return this.context.instance.acquireTokenRedirect(loginRequest);
      }
      throw e;
    });
  };

  requestProfileData() {
    // Silently acquires an access token which is then attached to a request for MS Graph data
    this.getToken()
      .then((tokenResponse) => {
        console.log('INFORMACION TOKEN -> ', tokenResponse);
        // return callMsGraph(tokenResponse.accessToken);
        return fetchAPI({
          service: 'v1/mdcolombia/admin/login',
          customHeaders: { authorization: tokenResponse?.accessToken },
          protocol: 'POST',
          params: {},
          skipAuth: true,
          callbackThen: (respond) => {
            const access_token = respond.access_token;
            const expires = respond.expires_in;
            localStorage.setItem('bearer', access_token);
            setCookie('bearer', access_token, { expires });
          },
          callbackError: () => {},
        });
      })
      .then((tokenResponse) => {
        console.log('INFORMACION TOKEN -> ', tokenResponse);
      })
      .catch((error) => {
        console.log('ERROR INFORMACION TOKEN -> ', error);
      });
  }

  getIndexOfActive = (array) => {
    array = array || [];
    return array.findIndex(({ active }) => active);
  };

  /* A function that is used to set the active item in the menu. */
  setActiveByIndex = (index) => {
    const { title } = this.state.menuItems[index] || {};
    this.setActiveByTitle(title);
  };

  getItemFromArrayByTitle = (array = [], title) =>
    array.find(({ title: itemTitle }) => itemTitle.trim().toLowerCase() === title.trim().toLowerCase());

  setActiveAsFalse = (array) =>
    array.forEach((itemArray) => {
      itemArray.active = false;
      if (itemArray.submenu) {
        this.setActiveAsFalse(itemArray.submenu);
      }
    });

  /* A function that is used to set the active item in the menu. */
  setActiveByTitle = (title) => {
    const { menuItems } = this.state;
    this.setActiveAsFalse(menuItems);
    const foundItem = this.getItemFromArrayByTitle(menuItems, title);

    if (foundItem) {
      foundItem.active = true;
      this.setState({ menuItems });
    }
  };

  setActiveBySubmenuTitle = (item, subitemTitle) => {
    const { menuItems } = this.state;

    this.setActiveAsFalse(menuItems);
    const foundItem = this.getItemFromArrayByTitle(menuItems, item.title);

    if (foundItem) {
      foundItem.active = true;
      const foundSubItem = this.getItemFromArrayByTitle(foundItem.submenu, subitemTitle);
      if (foundSubItem) {
        foundSubItem.active = true;
      }
      this.setState({ menuItems });
    }
  };

  handleOnClickItem = (item, subitemTitle) => {
    const { title, submenu } = item;
    if (submenu) {
      this.setActiveBySubmenuTitle(item, subitemTitle);
    } else {
      this.setActiveByTitle(title);
    }
  };

  getActiveItemMenu = () => {
    const currentItem = this.state.menuItems.find(({ active }) => active) || [{}];
    if (currentItem.submenu) {
      const currentSubmenuComponent = currentItem.submenu.find(({ active }) => active);
      return currentSubmenuComponent;
    }
    return currentItem;
  };

  handleToast = (args) => {
    const {
      open = false,
      message = '',
      timeoutClose = 3000,
      type = 'success', // error | success | info
      title,
    } = args;

    this.setState({
      snackbar: {
        open,
        title,
        message,
        severity: type,
      },
    });


  };

  setLoaderOpen = (loaderOpen) => this.setState({ loaderOpen });

  render() {
    const { state, handleOnClickItem, getActiveItemMenu, handleToast, setLoaderOpen } = this;

    const { menuItems, loaderOpen, snackbar } = state;

    const { component: RightView, title } = getActiveItemMenu();
    console.log('AdminMain render, loaderOpen:', loaderOpen);
    
    return (
      <div className={styles.container}>
        <div className={styles.container__left}>
          <Menu menuItems={menuItems} onClickItem={handleOnClickItem} />
        </div>
        <div className={styles.container__rigth}>
          {RightView && (
            <RightView title={title} loading={loaderOpen} setLoading={setLoaderOpen} handleToast={handleToast} />
          )}
        </div>

        <MazTuInfoBeesLoader open={loaderOpen} />

        <MazTuInfoBeesToast
          style={{ width: '500px', left: 'initial' }}
          snackbar={snackbar}
          setSnackbar={handleToast}
        />
      </div>
    );
  }
}

AdminMain.propTypes = propTypes;
AdminMain.defaultProps = defaultProps;

export default AdminMain;
